import { forwardRef } from 'react';
import { type DetailedHTMLProps, type SyntheticEvent } from 'react';

import goldIcon from './gold-icon.webp';

type Props = Omit<
  DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement | null>,
    HTMLDivElement
  >,
  'onClick'
> & {
  onClick?: (e: SyntheticEvent) => void;
};
export const GoldIcon = forwardRef<HTMLDivElement, Props>((props, ref) => {
  return (
    <div className="text-text400 flex text-sm" {...props} ref={ref}>
      <div className="flex flex-col justify-center">
        <img alt="gold-icon" className="h-[38px]" src={goldIcon} />
      </div>
      <div className="-mt-[6px] flex flex-col justify-center text-center">
        <span>Gold</span>
      </div>
    </div>
  );
});

GoldIcon.displayName = 'GoldIcon';
